module.exports = __webpack_public_path__ + "static/media/mc_lid_close.a5cb2ea6.svg";